/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Create new class for sliding text
 *
 * @params {Element} wrapper - HTML element with text content
 */
// class TextSliderUpper {
//   constructor(wrapper) {
//     this.wrapper = wrapper;

//     // Set delay between characters (in ms)
//     this.delay = 40;

//     // Wrap content in relevant wrappers
//     this._wrapContent();
//   }

//   _wrapContent() {
//     let words = this.wrapper.textContent.split(' ');
//     let delay = 0;
//     let content = '';

//     // Loop through each word, wrap each character in a span
//     words.forEach((word, multiplier) => {
//       let word_split = word.split(/([^\x00-\x80]|\w)/g);
//       let word_content = '';

//       // Look through each letter, add a delay (incremented)
//       word_split.forEach((char, index) => {
//         delay += this.delay;

//         word_content += `<span style="animation-delay: ${delay}ms">${char}</span>`;
//       });

//       // Add spacing between words
//       if (content !== '') content += ' ';

//       // Add wrapped words to content
//       content += `<span>${word_content}</span>`;
//     })

//     // Add content to wrapper
//     this.wrapper.innerHTML = content;
//   }

//   init() {
//     this.wrapper.classList.add('show');
//   }
// }

// // Get a list of all headers
// let headers = document.querySelectorAll('[data-animate]');

// // Loop through, add relevant class
// Array.from(headers).forEach(header => {
//   let slideHeader = new TextSliderUpper(header);

//   // Allow for delays? Sure!
//   let delay = header.dataset.delay || 0;

//   // Delay class (if necessary)
//   setTimeout(() => {
//     slideHeader.init();
//   }, delay)
// })

// heading animations




const containers = document.querySelectorAll(".hover--expended");
if (containers) {
  containers.forEach((f) =>
    f.addEventListener("mouseenter", function () {
      containers.forEach((e) => {
        e.classList.remove("active--layer");
      });
      f.classList.add("active--layer")
      
    }));
 containers.forEach((g) =>
   g.addEventListener("mouseleave", function () { 
     g.classList.remove("active--layer");
    }));
}

// document.addEventListener("DOMContentLoaded", function () {
//   const ele = document.querySelector(".Collection__list_custom");
//   if (ele) {
//     ele.style.cursor = "grab";

//     let pos = { top: 0, left: 0, x: 0, y: 0 };

//     const mouseDownHandler = function (e) {
//       ele.style.cursor = "grabbing";
//       ele.style.userSelect = "none";

//       pos = {
//         left: ele.scrollLeft,
//         top: ele.scrollTop,
//         // Get the current mouse position
//         x: e.clientX,
//         y: e.clientY,
//       };

//       document.addEventListener("mousemove", mouseMoveHandler);
//       document.addEventListener("mouseup", mouseUpHandler);
//     };

//     const mouseMoveHandler = function (e) {
//       // How far the mouse has been moved
//       const dx = e.clientX - pos.x;
//       const dy = e.clientY - pos.y;

//       // Scroll the element
//       ele.scrollTop = pos.top - dy;
//       ele.scrollLeft = pos.left - dx;
//     };

//     const mouseUpHandler = function () {
//       ele.style.cursor = "grab";
//       ele.style.removeProperty("user-select");

//       document.removeEventListener("mousemove", mouseMoveHandler);
//       document.removeEventListener("mouseup", mouseUpHandler);
//     };

//     // Attach the handler
//     ele.addEventListener("mousedown", mouseDownHandler);
//   }
// });
const body = document.body;
const header = document.querySelector("#shopify-section-header");

let lastScroll = 0;

// window.addEventListener("scroll", () => {
//     let currentScroll = window.pageYOffset;

//     // console.log("current: ", currentScroll);
//     // console.log("last: ", lastScroll);

//     if (currentScroll - lastScroll > 0) {
//         // scrolled down -- header hide
//         header.classList.add("scroll-down");
//         header.classList.remove("scroll-up");
//     } else {
//         // scrolled up -- header show
//         header.classList.add("scroll-up");
//         header.classList.remove("scroll-down");
//     }

//     lastScroll = currentScroll;
//     // console.log("last: ", lastScroll);

// })
function _addMeToCart(e, el) {
  e = e || window.event;
  e.preventDefault();
  document.dispatchEvent(new CustomEvent("theme:loading:start"));
  let formData = {
    items: [
      {
        id: el.dataset.variant_id,
        quantity: 1,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((resp) => {
      return resp.json();
    })
    .then((data) => {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
      // document.documentElement.dispatchEvent(
      //   new CustomEvent("cart:refresh", {
      //     bubbles: true,
      //   })
      // );
      document.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: el.dataset.variant_id,
            quantity: 1,
          },
        })
      );

    })
    .catch((err) => {
      console.error("Error: " + err);
    });
}


const contain = document.querySelectorAll('.Layers--Grid .hover--expend');
if(contain){

contain.forEach(f => f.addEventListener('mouseenter', function() {
  contain.forEach(e => {
   
    e.classList.add('disable--layer');
    e.classList.remove('active--layer');
  })
  f.classList.add('active--layer');
}))}


const containersH = document.querySelectorAll('.hover--expended');
if(containersH){

containersH.forEach(f => f.addEventListener('mouseenter', function() {
  containersH.forEach(e => {
   
    e.classList.add('disable--layer');
    e.classList.remove('active--layer');
  })
  f.classList.add('active--layer');
}))}

const containersb = document.querySelectorAll('.main_flip');
if(containersb){

containersb.forEach(f => f.addEventListener('click', function() {
parant = f.closest('.active--layer');
  parant.classList.toggle('flip_active');
  
}))}

const showmore = document.querySelectorAll('.show_Text');
if(showmore){

showmore.forEach(f => f.addEventListener('click', function() {
parant = f.closest('.show_more');
  parant.classList.toggle('show_more_active');
}))}

const showless = document.querySelectorAll('.show_less');
if(showless){

showless.forEach(f => f.addEventListener('click', function() {
parant = f.closest('.show_more');
  parant.classList.toggle('show_more_active');
}))}

// const myText = new SplitType('.Heading')

//        gsap.to('.Heading', {
//            y: 0,
//            stagger: 0.05,
//            delay: 0.2,
//            duration: .1
//        })

